import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PROFILE_CARDS } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";

export default function ProfileSelection() {
  const { openQuote, requestEstimate } = useDialogs();

  return (
    <section id="clients" data-testid="profile-selection-section" className="py-14 md:py-20 px-4 md:px-8 max-w-7xl mx-auto">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Nos clients</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3">
          Des solutions pour particuliers, professionnels et institutions
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-5">
        {PROFILE_CARDS.map((card, i) => (
          <motion.div
            key={card.key}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.06 }}
            className="bg-white border border-gray-200 rounded-2xl p-6 md:p-7 flex flex-col hover:border-navy/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-navy/5 flex items-center justify-center mb-5">
              <card.icon className="w-6 h-6 text-navy" />
            </div>
            <h3 className="font-heading font-semibold text-lg text-navy mb-2">{card.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">{card.text}</p>
            <Button
              data-testid={`profile-card-button-${card.key}`}
              onClick={() => (card.key === "particulier" ? requestEstimate({ source: "clients-particuliers" }) : openQuote(card.key))}
              variant="outline"
              className="border border-navy/30 text-navy rounded-full font-semibold hover:bg-navy hover:text-white transition-colors justify-between"
            >
              {card.button} <ArrowRight className="w-4 h-4" />
            </Button>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
